import DataHelpers from '../helpers/DataHelpers'
import DateHelpers from '../helpers/DateHelpers'
import TagStatusHelpers from '../helpers/TagStatusHelpers'
import NiceData from '../data/NiceData'
import AlertHelpers from './AlertHelpers'

export default class {
    static get stages() {
        return [
            {name: 'Created', visible: true},
            {name: 'Validation Requested'},
            {name: 'Valid', visible: true},
            {name: 'Insight Invoice Made'},
            {name: 'Sent', visible: true},
            {name: 'Reminder Sent'},
            {name: 'Paid', visible: true},
        ]
    }

    static saveInvoiceTags(charge) {
        const obj  = {
            tags:charge.tags,
            meta:charge.meta
        }
        NiceData.saveItem(obj)
    }

    static saveCharge(charge) {
        const {from, to} = charge
        const fromKey = NiceData.safelyGetKey(from)
        const toKey = NiceData.safelyGetKey(to)

        if(!fromKey || !toKey) {
            AlertHelpers.showAlert('Missing User Key - CHARGE NOT SAVED')
            return
        }

        from.key = fromKey
        to.key = toKey

        const fromTo = fromKey + '-' + toKey
        const month = DateHelpers.yearMonth(DateHelpers.backwardsToDate(charge.date))   //to format 2020-02
        const invoice = {
            month,
            from,
            to,
            status: 'outstanding',
            meta: {
                path: `app/billing/${month}/invoices`,
                key: fromTo,
            },
            tags: {}
        }
        TagStatusHelpers.addTag(invoice.tags, 'created')

        if(DataHelpers.isInsightUser(invoice.to))
            charge.internal = true
        
        if(charge.internal) {               //skip validation and commissions...
            invoice.internal = true
            TagStatusHelpers.addTag(invoice.tags, 'validation requested')
            TagStatusHelpers.addTag(invoice.tags, 'valid')
            TagStatusHelpers.addTag(invoice.tags, 'insight invoice made')
        }

        charge.stamp = DataHelpers.getStamp()

        NiceData.saveItem(invoice)

        let newCharge = {...charge}
        delete newCharge.from
        delete newCharge.to
        newCharge.invoice = fromTo
        newCharge.meta = {
            path: `app/billing/${month}/charges`,
            key: DataHelpers.getKey()
        }

        NiceData.saveItem(newCharge)

    }

}


// WEBPACK FOOTER //
// ./src/helpers/BillingHelpers.js